export default "__VITE_ASSET__CPP29FYy__"